import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const JsonView = ({ title, value }: { title: string; value: unknown }) => {
  if (value === null || value === undefined) return null;
  return (
    <Accordion disableGutters>
      <AccordionSummary>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          component="pre"
          sx={{
            m: 0,
            p: 1.5,
            bgcolor: 'action.hover',
            borderRadius: 1,
            fontSize: 12,
            overflow: 'auto',
            maxHeight: 480
          }}
        >
          {JSON.stringify(value, null, 2)}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default JsonView;
